import React, { Component } from 'react'
import { firebaseAuth, base } from '../../../../config/constants.js'
import UrgentOrderCard from './UrgentOrderCard'
import { Grid, Menu, Icon, } from 'semantic-ui-react'
import {Link} from 'react-router-dom'


function TopMenu(props) {
    return (

        <Menu>
            {/* HOME */}
            <Menu.Item name='video camera' onClick={props.showNoNumbers} color='red'>
                <Icon name='home' />
                <Link to={'/dashboard'}>HOME</Link>
            </Menu.Item>
        </Menu>
    )
}


export default class UrgentOrderView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            urgentOrders: [],
        }
    }

    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("rlx1 +++++++++:removeListener");
            if (user) {
              console.log("upx12 user is:"+user.email);

              this.setState({
                user:user,
              })
      
      
            } else {
              console.log("rlx121 user NOT found");

            }
          })

        /**
         * LOAD ORDERS
         */
        base.syncState('orders', {
            context: this,
            asArray: true,
            state: 'urgentOrders',
            queries: {
                orderByChild: 'urgent',
                equalTo: true
            }
        });
    }

    render() {

        const urgentOrder = this.state.urgentOrders.map((order) =>

            <Grid.Column>
                <UrgentOrderCard user={this.state.user} order={order} user={this.state.user} />
            </Grid.Column>
        )

        

        return (
            <div>
                <TopMenu/>

                <Grid stackable columns={3}>
                    {urgentOrder}
                </Grid>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/UrgentComponents/UrgentOrderView.js